import React, { useState, useEffect } from 'react';
import { Form, Select } from 'antd';
import countryList from 'react-select-country-list';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { useUpdateProfile, type OktaInfo } from '../hooks';
import * as Styled from '../styled';

const { Option } = Select;

interface Country {
  value: string;
  label: string;
}

interface Props {
  oktaData?: OktaInfo;
  isFederated?: boolean;
  standAlone?: boolean;
}

const formFields = [
  { label: 'First name', name: 'firstName', required: true, disable: false },
  { label: 'Last name', name: 'lastName', required: true, disable: false },
  { label: 'Job title', name: 'title', required: false, disable: false },
  { label: 'Department', name: 'department', required: false, disable: false },
  { label: 'Company name', name: 'companyName', required: false, disable: true },
];

export const PersonalInformation = (props: Props) => {
  const { oktaData, isFederated, standAlone } = props;
  const [countriesList, setCountriesList] = useState<Country[]>([]);
  const [selectedCountry, setSelectedCountry] = useState<string>('nothing');
  const { mutate: updateProfile, isLoading } = useUpdateProfile();

  useEffect(() => {
    const tempCountryList = countryList().getData();
    setCountriesList(tempCountryList);

    if (oktaData?.countryCode) {
      const country = tempCountryList.find(
        (country: Country) => country.value === oktaData.countryCode,
      );
      if (country) {
        setSelectedCountry(country.value);
      } else {
        setSelectedCountry('US');
      }
    } else {
      setSelectedCountry('US');
    }
  }, [oktaData?.countryCode]);

  const onFinish = async (values: unknown) => {
    const formValues = values as OktaInfo;
    const formData = {
      ...formValues,
      countryCode: selectedCountry,
      email: oktaData?.email,
    };
    updateProfile(formData);
  };

  return (
    <Styled.StyledForm
      name="layout-multiple-vertical"
      layout="vertical"
      labelCol={{ span: 14 }}
      wrapperCol={{ span: 10 }}
      onFinish={onFinish}
      initialValues={oktaData}
    >
      {formFields.map((field) => (
        <Styled.StyledFormItem
          key={field.name}
          label={field.label}
          name={field.name}
          rules={[
            ...(field.required ? [{ required: true, message: `${field.label} is required` }] : []),
          ]}
        >
          <Styled.StyledInput disabled={isFederated || field.disable} />
        </Styled.StyledFormItem>
      ))}

      <Styled.StyledFormItem label="Mobile Number" name="mobilePhone">
        <PhoneInput
          disabled={isFederated}
          country={'us'}
          inputStyle={{ width: '100%' }}
          dropdownStyle={{
            bottom: '100%',
            top: 'auto',
            marginBottom: '5px',
          }}
        />
      </Styled.StyledFormItem>

      <Styled.StyledSelect>
        <label>Country</label>
        <Select
          className="country-select"
          value={selectedCountry}
          disabled={isFederated}
          onChange={(val) => {
            setSelectedCountry(val);
          }}
        >
          {countriesList.map((country) => (
            <Option key={country.value} value={country.value}>
              {country.label}
            </Option>
          ))}
        </Select>
      </Styled.StyledSelect>

      <Form.Item wrapperCol={{ offset: 0, span: 16 }}>
        {!standAlone && (
          <Styled.StyledSubmitButton
            $disabled={!!(isFederated || isLoading)}
            type="primary"
            htmlType="submit"
            disabled={isFederated || isLoading}
            loading={isLoading}
          >
            Update
          </Styled.StyledSubmitButton>
        )}

      </Form.Item>
    </Styled.StyledForm>
  );
};
